export default function parseFullName(fullName) {
  return fullName.trim().split(/ (.+)/);
}
